export default {
  primary: '#0D47A1'
}



// WEBPACK FOOTER //
// ./src/config/theme.js